export var linkDefaultProps = {
  className: "",
  component: "a",
  minor: false,
  isButton: false,
  lineHeight: ""
};